/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-22 22:51:17
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-12-03 10:30:34
 * @FilePath: \vue-privilege-routing\src\api\index.js
 */
import axios from "../utils/http"
import store from "../store"

export function fetchPermission(){
    return axios.get("/auths/module/selectAllModule.do");
}

export function doLogin(data){
    return axios.post("/auths/commonLogin/logoAccount.do",data)
}

export function checkLogin(data){
    return axios.post("/auths/commonLogin/checkAccount.do",data)
}
export function getInformation(data){
    return axios.post("/auths/commonLogin/getInformation.do",data)
}

export function createTable(data){
    return axios.post("/auths/dbGenerate/createTable.do",data)
}

export function registerSubmit(data){
    return axios.post("/auths/register/registerSave.do",data)
}

export function selectUnitList(data){
    return axios.post("/auths/adminUnit/selectUnit.do",data)
}

export function insertUnit(data){
    return axios.post("/auths/adminUnit/insertUnit.do",data)
}

export function selectDictList(data){
    return axios.post("/auths/dict/selectDictList.do",data)
}

export function getDict(data){
    return axios.post("/auths/dict/getDict.do",data)
}

export function deleteDict(dictId){
    return axios.get("/auths/dict/deleteDict.do?dictId="+ dictId)
}

export function writeDict(data){
    return axios.post("/auths/dict/writeDict.do",data)
}

export function selectDictGroup(){
    return axios.get("/auths/dict/selectDictGroup.do")
}

export function selectDictByGroup(data){
    return axios.post("/auths/dict/selectDictByGroup.do",data)
}

export function selectGoodsList(data){
    return axios.post("/goods/goods/selectGoods.do",data)
}